/**
 * Returns safe, significant words for order-independent PostgREST name searches.
 * Each returned token can be added as its own `ilike('name', `%token%`)` filter.
 */
export function nameSearchTokens(query: string, minimumLength = 2): string[] {
  const safe = (query || '')
    .replace(/[,()%*_\\"]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (safe.length < minimumLength) return [];
  return [...new Set(safe.split(' ').filter(Boolean))];
}

export function includesEveryNameToken(name: string, query: string): boolean {
  const tokens = nameSearchTokens(query).map(token => token.toLocaleLowerCase('fr'));
  const candidate = name.toLocaleLowerCase('fr');
  return tokens.length > 0 && tokens.every(token => candidate.includes(token));
}
